export const CREATE_TASK_GROUP_REQUEST = "CREATE_TASK_GROUP_REQUEST";
export const CREATE_TASK_GROUP_SUCCESS = "CREATE_TASK_GROUP_SUCCESS";
export const CREATE_TASK_GROUP_FAIL = "CREATE_TASK_GROUP_FAIL";
export const CREATE_TASK_GROUP_RESET = "CREATE_TASK_GROUP_RESET";

export const GET_ALL_TASK_GROUPS_REQUEST = "GET_ALL_TASK_GROUPS_REQUEST";
export const GET_ALL_TASK_GROUPS_SUCCESS = "GET_ALL_TASK_GROUPS_SUCCESS";
export const GET_ALL_TASK_GROUPS_FAIL = "GET_ALL_TASK_GROUPS_FAIL";

export const GET_TASK_GROUP_DETAILS_REQUEST = "GET_TASK_GROUP_DETAILS_REQUEST";
export const GET_TASK_GROUP_DETAILS_SUCCESS = "GET_TASK_GROUP_DETAILS_SUCCESS";
export const GET_TASK_GROUP_DETAILS_FAIL = "GET_TASK_GROUP_DETAILS_FAIL";

export const UPDATE_TASK_GROUP_REQUEST = "UPDATE_TASK_GROUP_REQUEST";
export const UPDATE_TASK_GROUP_SUCCESS = "UPDATE_TASK_GROUP_SUCCESS";
export const UPDATE_TASK_GROUP_FAIL = "UPDATE_TASK_GROUP_FAIL";
export const UPDATE_TASK_GROUP_RESET = "UPDATE_TASK_GROUP_RESET";

export const DELETE_TASK_GROUP_REQUEST = "DELETE_TASK_GROUP_REQUEST";
export const DELETE_TASK_GROUP_SUCCESS = "DELETE_TASK_GROUP_SUCCESS";
export const DELETE_TASK_GROUP_FAIL = "DELETE_TASK_GROUP_FAIL";
export const DELETE_TASK_GROUP_RESET = "DELETE_TASK_GROUP_RESET";

export const CLEAR_ERRORS = "CLEAR_ERRORS";